export default class RotationRandom{
    constructor(element){
        this.element = element
        this.init()
    }

    init(){
        let sticker = this.element.querySelector('[data-sticker]')
        let rotation = Math.floor((Math.random() * 10) - 5);
        if(sticker != null){
            sticker.style.setProperty('--rotation', rotation + 'deg');
        } 
    }
}